import axios from "axios";

const baseURL = "https://api.plantgenie.org";

const axiosClient = axios.create({ baseURL: baseURL });

const getDatabaseName = (db: string) => {
  switch (db) {
    case 'potra':
      return 'beta_plantgenie_potra_v22';
    case 'piabi':
      return 'beta_plantgenie_piabi_v10';
    default:
      return 'beta_plantgenie_potra_v22';
  }
};

const getMappedDataset = (dataset: string, database: string) => {
  if (database === 'piabi' && dataset === 'ze') {
    return 'zygotic';
  }
  if (database === 'plantgenie' && dataset === 'leaf_development') {
    console.log('Mapping leaf_development to performed for potra');
    return 'terminal';
  }
  return dataset;
};

export async function getExperimentData(database: string) {
  return axiosClient.get(`/experiment/get_all?name=${getDatabaseName(database)}`);
}

export async function getHeatmapData(
  parameters,
  dataset,
  normalised,
  axis,
  rowDistance,
  rowLinkage,
  database: string
) {
  console.log('Database passed to getHeatmapData:', database);
  const mappedDataset = getMappedDataset(dataset, database);
  console.log('Original dataset:', dataset, 'Mapped dataset:', mappedDataset);
  return axiosClient.post(
    "/exheatmap/index.php",
    "gene_ids=" +
    parameters +
    "&file_id=&dataset=" +
    mappedDataset +
    "&axis=" +
    axis +
    "&row_distance=" +
    rowDistance +
    "&row_linkage=" +
    rowLinkage +
    "&normalised=" +
    normalised +
    "&sample_id=true&name=" + getDatabaseName(database)
  );
}